import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FaKey, FaUserFriends } from "react-icons/fa";
import {
  getCurrentPackageUser,
  getProfile,
  pinLogin,
  resetSecret,
  userLoginWithSecret,
} from "../services/api";
import {
  getToken,
  setCookie,
  removeCookie,
  deleteToken,
} from "../services/cookies";
import Notiflix from "notiflix";

export default function Login() {
  const [secretKey, setSecretKey] = useState("");
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { id: uuid } = useParams(); // URL'den UUID'yi al
  const [data, setData] = useState(null);
  const [profileData, setProfileData] = useState(null);
  const [diffUser, setDiffUser] = useState(false);
  const [showResetModal, setShowResetModal] = useState(false);
  const [resetEmail, setResetEmail] = useState("");
  const [resetLoading, setResetLoading] = useState(false);

  // Mevcut hesaptan çıkış yap
  const handleLogout = () => {
    deleteToken("jodiactoken");
    window.location.reload();
  };

  // Mevcut hesaba geçiş yap
  const handleSwitchAccount = () => {
    if (profileData?.user?.id) {
      navigate(`/${profileData.user.id}`);
    }
  };

  const handleForgotSecret = () => {
    setShowResetModal(true);
  };

  const handleResetSecret = async (e) => {
    e.preventDefault();
    setResetLoading(true);

    try {
      await resetSecret(uuid, resetEmail);
      Notiflix.Notify.success(
        "Gizli anahtarınız e-posta adresinize gönderildi!"
      );
      setShowResetModal(false);
      setResetEmail("");
    } catch (error) {
      console.error("Reset secret error:", error);
      Notiflix.Notify.failure(
        "E-posta gönderilirken bir hata oluştu. Lütfen tekrar deneyin."
      );
    } finally {
      setResetLoading(false);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      let response;

      // UUID yoksa email ile login
      if (!uuid) {
        if (!email) {
          setError("Lütfen email adresinizi giriniz.");
          setLoading(false);
          return;
        }
        response = await userLoginWithSecret(email, secretKey);

        // Token'ı cookies'a kaydet
        if (response.token) {
          setCookie(response.token);
        }
        // Başarılı giriş sonrası, kullanıcının ID'sine yönlendir
        if (response.uuid) {
          navigate("/" + response.uuid);
        } else {
          navigate("/");
        }
      } else {
        // UUID varsa mevcut pinLogin
        response = await pinLogin(uuid, secretKey);

        // Token'ı cookies'a kaydet
        if (response) {
          setCookie(response);
        }

        // Başarılı giriş sonrası ana sayfaya yönlendir
        navigate("/" + uuid);
      }
    } catch (error) {
      console.error("Login error:", error);

      // Hata mesajını kullanıcıya göster
      if (error.response?.data?.message) {
        setError(error.response.data.message);
      } else if (error.message) {
        setError("Giriş bilgileri hatalı.");
      } else {
        setError("Giriş yapılırken bir hata oluştu. Lütfen tekrar deneyin.");
      }
    } finally {
      setLoading(false);
    }
  };

  const fetchProfile = async () => {
    if (uuid) {
      const response = await getCurrentPackageUser(uuid);
      setData(response);
      const token = getToken("jodiactoken");
      if (token) {
        const response = await getProfile();
        setProfileData(response);
        if (response.user && response.user.id !== uuid) {
          setDiffUser(true);
        }
      }
    }
  };

  useEffect(() => {
    // Notiflix'i initialize et
    Notiflix.Notify.init({
      position: "top-right",
      timeout: 3000,
      clickToClose: true,
      pauseOnHover: true,
    });

    // Sadece UUID varsa profil bilgilerini çek
    if (uuid) {
      fetchProfile();
    }
  }, [uuid]);

  return (
    <div className="h-screen max-h-screen overflow-hidden flex bg-white flex-col items-center justify-start">
      <div
        className="text-center h-[120px] w-full sm:max-w-[390px] flex items-center justify-center"
        style={{
          backgroundImage: "url(/assets/pngImages/welcomeScreen.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <img
          src="/assets/pngImages/jodiacLogo.png"
          alt="JODIAC Logo"
          className="h-[150px] mb-4 w-auto"
        />
      </div>
      <div className="w-full min-h-full bg-white shadow-xl border border-gray-200 rounded-none sm:max-w-[390px] sm:h-[700px] sm:rounded-3xl relative overflow-y-auto">
        {/* Logo */}
        {data ? (
          <div className="flex flex-col mt-6 items-center justify-center px-5">
            <div className="flex gap-4 items-start justify-center w-full">
              <div className="flex-shrink-0">
                {data?.pictureDetails?.pictureUrl ? (
                  <img
                    src={data.pictureDetails.pictureUrl}
                    alt="Profile"
                    className="w-12 h-12 rounded-full object-cover"
                  />
                ) : (
                  <div className="w-12 h-12 rounded-full bg-gray-200 flex items-center justify-center">
                    <span className="text-gray-700 text-xl font-semibold">
                      {data?.first_name?.charAt(0)?.toUpperCase()}
                    </span>
                  </div>
                )}
              </div>
              <div className="text-left">
                <div className="text-lg text-black font-semibold">
                  {data?.first_name} {data?.last_name}
                </div>
                <p className="text-black text-sm mt-1">
                  Seni tekrardan görmek güzel!
                </p>
              </div>
            </div>
          </div>
        ) : null}
        {diffUser ? (
          <div className="text-center mb-4 px-5 mt-4">
            <div className="">
              <p className="text-gray-800 text-sm mb-3">
                Giriş yapmış olduğunuz bir hesap mevcut. (
                {profileData?.profile?.details?.first_name})<br />
                Lütfen seçeneklerden birini seçiniz.
              </p>
              <div className="flex h-10  justify-between  gap-4">
                <button
                  onClick={handleLogout}
                  className="w-full text-xs  border bg-white border-1 border-red-500 text-red-500 py-2.5 rounded-lg font-normal hover:bg-red-600 transition-colors duration-200"
                >
                  Çıkış Yap
                </button>
                <button
                  onClick={handleSwitchAccount}
                  className="w-full text-xs bg-[#3DA7B5] text-white py-2.5 rounded-lg font-normal hover:bg-[#3DA7B5]/80 transition-colors duration-200"
                >
                  Geçiş Yap ({profileData?.profile?.details?.first_name})
                </button>
              </div>
            </div>
          </div>
        ) : null}
        {/* Hata Mesajı */}
        {error && (
          <div className="mb-4 px-5">
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-full text-sm">
              {error}
            </div>
          </div>
        )}

        {/* Form */}
        <form onSubmit={handleLogin} className="flex-1 flex flex-col px-5">
          <div className="space-y-3">
            {/* Email Alanı - Sadece UUID yoksa göster */}
            {!uuid && (
              <div>
                <input
                  type="email"
                  placeholder="E-posta Adresiniz"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full mt-5 bg-white px-4 py-2.5 rounded-full border-1 border-[#E9E9E9] shadow-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#3DA7B5]/20 text-center text-xl tracking-widest font-semibold"
                  required
                  disabled={loading}
                />
              </div>
            )}

            {/* Gizli Anahtar Alanı */}
            <div>
              <input
                type="text"
                inputMode="numeric"
                placeholder="Gizli Anahtar (4 Haneli)"
                value={secretKey}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  if (value.length <= 4) {
                    setSecretKey(value);
                  }
                }}
                maxLength={4}
                className="w-full mt-3 bg-white px-4 py-2.5 rounded-full border-1 border-[#E9E9E9] shadow-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#3DA7B5]/20 text-center text-xl tracking-widest font-semibold"
                required
                disabled={loading}
              />
            </div>
          </div>

          <div className="space-y-3 mt-6">
            {/* Giriş Yap Butonu */}
            <button
              type="submit"
              className="w-full bg-[#3DA7B5] text-white py-2.5 rounded-lg font-normal hover:bg-[#3DA7B5]/80 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={loading}
            >
              {loading ? "Giriş Yapılıyor..." : "Giriş Yap"}
            </button>

            <button
              type="button"
              onClick={handleForgotSecret}
              className="w-full bg-white text-[#6C6C6E] py-2.5 rounded-lg font-normal transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
              disabled={loading}
            >
              <FaKey className="w-4 h-4" />
              Gizli Anahtarımı Unuttum
            </button>

            {/* Başka kullanıcı ile giriş yap butonu - Sadece UUID'li sayfalarda göster */}
            {uuid && (
              <a
                href="/login"
                className="w-full bg-white text-[#6C6C6E] py-2.5 rounded-lg font-normal transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed border border-gray-300 flex items-center justify-center gap-2"
              >
                <FaUserFriends className="w-4 h-4" />
                Başka kullanıcı ile giriş yap
              </a>
            )}
          </div>
        </form>

        <div className="flex flex-col justify-center items-center px-5 pb-4">
          <div className=" w-[179px] border-b border-[#E2E2E2] text-white text-sm">
            {" "}
            &nbsp;{" "}
          </div>
          <a href="https://jodi.ac" target="_blank" className="w-full mt-4">
            <img
              src="/assets/pngImages/loginBanner.png"
              alt="JODIAC Logo"
              className="w-full h-auto min-h-[128px] max-h-[198px] object-contain"
            />
          </a>
        </div>
      </div>

      {/* Gizli Anahtar Sıfırlama Modal */}
      {showResetModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-5">
          <div className="bg-white rounded-2xl p-6 w-full max-w-md shadow-xl">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">
              Gizli Anahtarımı Unuttum
            </h2>
            <p className="text-sm text-gray-600 mb-6">
              E-posta adresinizi girin, gizli anahtarınız size gönderilsin.
            </p>

            <form onSubmit={handleResetSecret}>
              <input
                type="email"
                placeholder="E-posta Adresiniz"
                value={resetEmail}
                onChange={(e) => setResetEmail(e.target.value)}
                className="w-full bg-white px-4 py-3 rounded-lg border border-gray-300 text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#3DA7B5]/50 focus:border-[#3DA7B5] mb-4"
                required
                disabled={resetLoading}
              />

              <div className="flex gap-3">
                <button
                  type="button"
                  onClick={() => {
                    setShowResetModal(false);
                    setResetEmail("");
                  }}
                  className="flex-1 bg-gray-200 text-gray-700 py-2.5 rounded-lg font-normal hover:bg-gray-300 transition-colors duration-200"
                  disabled={resetLoading}
                >
                  İptal
                </button>
                <button
                  type="submit"
                  className="flex-1 bg-[#3DA7B5] text-white py-2.5 rounded-lg font-normal hover:bg-[#3DA7B5]/80 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
                  disabled={resetLoading}
                >
                  {resetLoading ? "Gönderiliyor..." : "Gönder"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
